import type {
  CookieCategory,
  CookieRecord,
} from '../../../services/cookieTranslationService/types'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { CookieOverview } from '#src/assets/ui/overview/components/CookieOverview.tsx'
import { SettingsDialogDescription } from '#src/assets/ui/settings/components/Description.tsx'
import { SettingsDialogFooter } from '#src/assets/ui/settings/components/Footer.tsx'
import { SettingsDialogHeader } from '#src/assets/ui/settings/components/Header.tsx'
import { FloatingPanel } from '#src/assets/ui/shared/components/FloatingPanel.tsx'
import type { SiteConfig } from '#src/models/site-configs/siteConfigs.ts'

export function SettingsDialog({
  t,
  locale,
  siteConfig,
  cookiesByCategory,
  visible,
  onClose,
  onAdjustPreferences,
}: {
  t: CookieConsentTranslator
  locale: string
  siteConfig: SiteConfig
  cookiesByCategory: Record<CookieCategory, Array<CookieRecord>>
  visible: boolean
  onClose: () => void
  onAdjustPreferences: () => void
}) {
  return (
    <FloatingPanel
      visible={visible}
      maxWidth="22rem"
      style={{ fontWeight: '400' }}
    >
      <SettingsDialogHeader t={t}>
        <SettingsDialogDescription t={t} />
      </SettingsDialogHeader>

      <CookieOverview
        t={t}
        locale={locale}
        siteConfig={siteConfig}
        cookiesByCategory={cookiesByCategory}
      />
      <SettingsDialogFooter
        t={t}
        onAdjustPreferences={onAdjustPreferences}
        onClose={onClose}
      />
    </FloatingPanel>
  )
}
